import Vue from 'vue';
import AhaBackend from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { App } from '@capacitor/app';
import { SplashScreen } from '@capacitor/splash-screen';
import explorer from './plugins/explorer';
import persistentStorage from './plugins/persistentStorage';
import authentication from './plugins/authentication';
import organization from './plugins/organization';
import i18n, { i18nSetup } from './plugins/i18n';
import components from './plugins/components';
import eventManager from './plugins/eventManager';
import pushNotifications from './plugins/pushNotifications';
import filters from './filters';
import moment from 'moment';
import './registerServiceWorker';
import { MAGIC_LOGIN_TOKEN_PARAMETER, FORCE_LOGIN_PARAMETER } from './config/constants';

moment.locale(process.env.VUE_APP_I18N_LOCALE);

Vue.use(persistentStorage, { router });
Vue.use(explorer, {
    baseUrl: process.env.VUE_APP_API_HOST,
    imagesSubPath: 'uploads',
});
Vue.use(authentication, { router });
Vue.use(organization);
Vue.use(eventManager);
Vue.use(pushNotifications);

i18nSetup(router);

Vue.use(components);

Vue.use(filters);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(AhaBackend),
    i18n,
    mounted() {
        App.addListener('appUrlOpen', function (data) {
            const url = new URL(data.url);
            const token = url.searchParams.get('magic-login-token'); // "562"
            if (token) {
                Vue.$store.commit('user/setMagicLoginToken', queryParams[MAGIC_LOGIN_TOKEN_PARAMETER]);
            }
          });
        SplashScreen.hide();
        Vue.$router.onReady(() => {
            let queryChanged = false;
            const queryParams = { ...Vue.$router.currentRoute.query };
            if (queryParams[MAGIC_LOGIN_TOKEN_PARAMETER]) {
                Vue.$store.commit('user/setMagicLoginToken', queryParams[MAGIC_LOGIN_TOKEN_PARAMETER]);
                delete queryParams[MAGIC_LOGIN_TOKEN_PARAMETER];
                queryChanged = true;
            }
            if (queryParams[FORCE_LOGIN_PARAMETER]) {
                Vue.$store.commit('user/setForceLogin', queryParams[FORCE_LOGIN_PARAMETER]);
                delete queryParams[FORCE_LOGIN_PARAMETER];
                queryChanged = true;
            }
            if (queryChanged) {
                Vue.$router.replace({ query: queryParams });
            }
        });
    },
}).$mount('#app');
